module.exports = __webpack_public_path__ + "img/375_news_main_img1.dd3dfe3c.png";